import { SafePromise } from '@benzinga/safe-await';

import { Session } from '@benzinga/session';
import { Commodity } from './entities';
import { CommoditiesRequest, CommoditiesRequestEvent } from './request';
import { ExtendedSubscribable } from '@benzinga/subscribable';

interface CommoditiesFunctions {
  getCommodities: CommoditiesManager['getCommodities'];
  getCommodity: CommoditiesManager['getCommodity'];
  getCommodityCateogries: CommoditiesManager['getCommodityCateogries'];
}

export type CommoditiesManagerEvent = CommoditiesRequestEvent;

export class CommoditiesManager extends ExtendedSubscribable<CommoditiesManagerEvent, CommoditiesFunctions> {
  private request: CommoditiesRequest;

  constructor(session: Session) {
    super();
    this.request = new CommoditiesRequest(session);
  }

  public static getName = () => 'benzinga-commodities';

  public getCommodities = async (category: string): SafePromise<Commodity[] | undefined> => {
    return await this.request.getCommodities(category);
  };

  public getCommodity = async (symbol: string): SafePromise<Commodity | undefined> => {
    return await this.request.getCommodity(symbol);
  };

  public getCommodityCateogries = (): string[] => {
    return ['Commodities', 'Forex', 'Index', 'Bonds'];
  };

  protected onSubscribe(): CommoditiesFunctions {
    return {
      getCommodities: this.getCommodities,
      getCommodity: this.getCommodity,
      getCommodityCateogries: this.getCommodityCateogries,
    };
  }
}
